import { ValidationResult } from './ValidationResult';

const FormValidation = {};

FormValidation.isEmpty = (value, name) => {
    const result = new ValidationResult();
    name = name || 'Field';
    let input = value || '';

    input = value.trim();
    input = input.replace(/\s{2,}/g, ' ');

    if (!input) {
        result.success = false;
        result.message = `${name} Required`;
        return result;
    }

    result.success = true;
    return result;
};

FormValidation.isFormatValid = (regex, value, name) => {
    const result = new ValidationResult();
    name = name || 'Field';
    const input = value || '';

    if (!regex.test(input)) {
        result.success = false;
        result.message = `${name} Invalid`;
        return result;
    }

    result.success = true;
    return result;
};


FormValidation.validateEmail = (email) => {
    const fieldName = 'Email Address';
    let result = FormValidation.isEmpty(email, fieldName);
    if (!result.success) {
        return result;
    }

    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    result = FormValidation.isFormatValid(regex, email, fieldName);

    return result;
};


FormValidation.validateConfirmNo = (confirmNo) => {
    const fieldName = 'Access code';
    let result = FormValidation.isEmpty(confirmNo, fieldName);
    if (!result.success) {
        return result;
    }

    const regex = /^N\d{10}$/i
    result = FormValidation.isFormatValid(regex, confirmNo, fieldName);

    return result;
};

export default FormValidation;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Login/FormValidation.js